/**
 * ZoneDesignerTab — Wrapper around the self-contained GeofenceTool component.
 *
 * GeofenceTool is a Mapbox GL JS editor that reads session directly via
 * ReactSession and uses ApiRequester for its own save operations.
 * We simply mount it inside a pp-section card and wire up the refresh callback.
 *
 * Props:
 *   latitude   — campus center latitude
 *   longitude  — campus center longitude
 *   campusId   — campus ID (passed through to GeofenceTool for API calls)
 *   campusName — campus name (displayed in GeofenceTool)
 *   zoneData   — geo2 array from getgeofence2 (existing zones for the editor)
 *   zoneTypes  — att_zone_types array (zone type definitions for dropdown)
 *   onRefresh  — callback to trigger geofence data re-fetch in orchestrator
 */

import GeofenceTool from '../../../../../components/component-assets/GeofenceTool.jsx';

const ZoneDesignerTab = ({ latitude, longitude, campusId, campusName, zoneData, zoneTypes, onRefresh }) => {
  return (
    <div className="pp-section">
      <div className="pp-section__header">
        <h3 className="pp-section__title">Zone Designer</h3>
      </div>
      <div className="pp-section__body" style={{ padding: 0 }}>
        <GeofenceTool
          latitude={latitude}
          longitude={longitude}
          campusId={campusId}
          campus={campusName}
          startup={true}
          zoneData={zoneData}
          zoneTypes={zoneTypes}
          setCount={onRefresh}
        />
      </div>
    </div>
  );
};

export default ZoneDesignerTab;
